import { createStart } from '@tanstack/react-start';

import { requestLoggerMiddleware } from './lib/middleware/requestLogger';

// Initialize tracing on server startup
// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
if (globalThis.window === undefined) {
  const { initializeInstrumentation } = await import('./lib/tracing/instrumentation');
  await initializeInstrumentation();
}

export const startInstance = createStart(() => {
  return {
    requestMiddleware: [requestLoggerMiddleware],
    functionMiddleware: [],
  };
});
